var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({staticClass:"ib-select ib-input",attrs:{"outlined":""},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_s,k){return {key:k,fn:function(props){return [_vm._t(k,null,null,props)]}}})],null,true)},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }